import React, { useState } from "react";
import { useForm } from "react-hook-form";
import styles from "./WalletAdjustmentModal.module.css";
import { Services } from "../../../Services";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
const WalletAdjustmentModal = ({ isOpen, setisOpen, id, refetch }) => {
    const [loading, setLoading] = useState(false);
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();
    const onClose = () => {
        setisOpen(false);
    };
    const handleFormSubmit = (data) => {
        data.transaction_type = parseInt(data.transaction_type); // Convert to number
        let body = { ...data, id };
        reset();
        onClose();
        Services.getWalletAdjustment("POST", JSON.stringify(body), token, id)
            .then((res) => {
                if (res.Status === 1) {
                    refetch();
                    toast.success(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    // setOrdersSearch(res.Orders);
                } else if (res.Status === 0) {
                    setLoading(false);
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <h2>Adjust Wallet</h2>
                    <button className={styles.closeBtn} onClick={onClose}>
                        &times;
                    </button>
                </div>
                <form
                    onSubmit={handleSubmit(handleFormSubmit)}
                    className={styles.form}>
                    <div className={styles.formGroup}>
                        <label>Amount</label>
                        <input
                            type="number"
                            placeholder="Enter amount"
                            {...register("amount", {
                                required: true,
                                valueAsNumber: true,
                            })}
                        />
                        {errors.amount && (
                            <span className={styles.error}>
                                Amount is required
                            </span>
                        )}
                    </div>

                    <div className={styles.formGroup}>
                        <label>Note</label>
                        <textarea
                            rows="3"
                            placeholder="Add an optional note"
                            {...register("note", { required: true })}
                        />
                        {errors.note && (
                            <span className={styles.error}>
                                Note is required
                            </span>
                        )}
                    </div>

                    <div className={styles.formGroup}>
                        <label>Transaction Type</label>
                        <div className={styles.radioGroup}>
                            <label className={styles.radioLabel}>
                                <input
                                    type="radio"
                                    value="1"
                                    {...register("transaction_type", {
                                        required: true,
                                    })}
                                />
                                Credit
                            </label>
                            <label className={styles.radioLabel}>
                                <input
                                    type="radio"
                                    value="2"
                                    {...register("transaction_type", {
                                        required: true,
                                    })}
                                />
                                Debit
                            </label>
                        </div>
                        {errors.transaction_type && (
                            <span className={styles.error}>
                                Type is required
                            </span>
                        )}
                    </div>

                    <div className={styles.actions}>
                        <button type="submit" className={styles.submitBtn}>
                            {loading ? "...loading" : "Submit"}
                        </button>
                        <button
                            type="button"
                            className={styles.cancelBtn}
                            onClick={onClose}>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default WalletAdjustmentModal;
